import React, {useState} from "react";
import {LoaderFunctionArgs, useLoaderData, useParams} from "react-router-dom";
import PaymentsDataGrid from "../components/PaymentsDataGrid";
import axios from "axios";
import {Snackbar} from "@mui/material";

export interface Payment {
    id: number
    playerName : string
    characterName : string
    event: boolean | null
    parking: boolean | null
    meal: boolean | null
    secondary: boolean | null
}

export const paymentsLoader = async ({params}: LoaderFunctionArgs): Promise<{payments: Payment[], paidParking: boolean}> => {
    if (!params.eventId) return {payments: [], paidParking: true}
    const [payments, event] = await Promise.all([
        axios.get(`/api/events/${params.eventId}/payment/`).then(r => r.data),
        axios.get(`/api/events/${params.eventId}`).then(r => r.data)
    ])
    return {payments, paidParking: event?.paid_parking ?? true}
}

export default function Payments() {
    const {eventId} = useParams<{eventId: string}>()
    const loaderData = useLoaderData() as {payments: Payment[], paidParking: boolean}
    const [payments, setPayments] = useState(loaderData.payments);
    const paidParking = loaderData.paidParking;
    const [open, setOpen] = React.useState(false);

    const savePayment = async (p : Payment) => {
        const apiEndpoint = `/api/events/${eventId}/payment/` + p.id
        await axios.post(apiEndpoint,p).then(({data}) => {
            setOpen(true)
        })
    }

    const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    return (
        <React.Fragment>
        <PaymentsDataGrid payments={payments} paidParking={paidParking} onEdit={savePayment}/>
            <Snackbar
                open={open}
                autoHideDuration={6000}
                onClose={handleClose}
                message="Payment Updated"
            />
        </React.Fragment>
    )
}